import React from 'react';

const ACTIONS = [
  {icon: '❓', label: 'Help', key: 'help'},
];

const LCVActionSidebar = ({onExit}) => {
  return (
    <div className="lcv-nav-rail">
      <button type="button" className="lcv-btn-exit lcv-btn-exit-rail" onClick={onExit}>
        Exit
      </button>

      <div className="lcv-action-sidebar">
        {ACTIONS.map(action => (
          <button
            type="button"
            key={action.key}
            className="lcv-action-btn"
          >
            <span className="lcv-action-icon">{action.icon}</span>
            <span className="lcv-action-label">{action.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LCVActionSidebar;
